module.exports = __webpack_public_path__ + "img/201805-5.55c12100.jpeg";